export type TNumberProperty = {
	value: number;
	epoch: number;
} | undefined;

export const convertToNumberProperty = (value: string, epoch: string, divider = 1, badValue?: string[]): TNumberProperty | undefined => {
	if (!value || !epoch) {
		return undefined;
	}

	if (badValue && badValue.indexOf(value) !== -1) {
		return undefined;
	}

	return {
		value: Number.parseFloat(value) / divider,
		epoch: Number.parseInt(epoch, 10),
	};
};
